// extracted by mini-css-extract-plugin
export default {"success":"donors_success__JXlia","fail":"donors_fail__zPwUP","num":"donors_num__cgshN","title":"donors_title__7++q+"};